/**
 * @author David Oravec<xorave06@stud.fit.vutbr.cz>
 */

const isAdministrator = (user) => {
    if(user === undefined || user === null) return false
    return Number(user.role) === 2
}

const isLicitator = (user) => {
    if(user === undefined || user === null) return false
    const role = Number(user.role)
    return role === 1 || role === 2
}

const isAuthenticated = (user) => {
    if(user === undefined || user === null) return false
    return user.id > 0;
}

module.exports = {isAdministrator, isLicitator, isAuthenticated}